import LegalInfo from "../LegalInfo";
import RefuseBiometrics from "../RefuseBiometrics";
import AcceptedBiometrics from "../ActivatedBiometrics";
import BiometricErrorFeedback from "../BiometricErrorFeedback";

import { Authentication } from "../../../types/types";
import LoadingSpinner from "../../common/LoadingSpinner";

interface LoginGateProps {
  biometrics: Authentication["biometrics"];
  handleBiometricAccept: () => void | Promise<void>;
  spinnerClassName?: string;
  onRefuse?: () => void;
  showLoadingOnIdle?: boolean;
  loadingLabel?: string;
}

const noop = () => {};

const LoginGate = ({
  biometrics,
  handleBiometricAccept,
  spinnerClassName,
  onRefuse,
  showLoadingOnIdle,
  loadingLabel,
}: LoginGateProps) => {
  if (!biometrics) return null;

  if (biometrics.error) {
    return <BiometricErrorFeedback />;
  }

  if (biometrics.optInPage === "LEGAL_INFO") {
    return <LegalInfo handleBiometricAccept={handleBiometricAccept} />;
  }

  if (biometrics.optInPage === "REFUSE_BIOMETRICS") {
    return <RefuseBiometrics handleRefuseBiometrics={onRefuse ?? noop} />;
  }

  if (biometrics.optInPage === "ACCEPTED_BIOMETRICS") {
    return <AcceptedBiometrics />;
  }

  if (showLoadingOnIdle) {
    return (
      <LoadingSpinner
        className={spinnerClassName}
        size="lg"
        label={loadingLabel}
      />
    );
  }

  return null;
};

export default LoginGate;
